module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/productos/talle/talle.component.scss
// module id = ./src/app/productos/talle/talle.component.scss
// module chunks = main